/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeliveryAdminDto } from '../models/DeliveryAdminDto';
import type { DeliveryDriverDto } from '../models/DeliveryDriverDto';
import type { DeliveryStatus } from '../models/DeliveryStatus';
import type { GetDeliveryActivityDriverResponse } from '../models/GetDeliveryActivityDriverResponse';
import type { GetDeliveryActivitySummaryDriverResponse } from '../models/GetDeliveryActivitySummaryDriverResponse';
import type { Pagination1OfDeliveryListedDriverDto } from '../models/Pagination1OfDeliveryListedDriverDto';
import type { PostCancelDeliveryAdminRequest } from '../models/PostCancelDeliveryAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DeliveriesService {
    /**
     * @returns DeliveryDriverDto OK
     * @throws ApiError
     */
    public static getDeliveryDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<DeliveryDriverDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/deliveries/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfDeliveryListedDriverDto OK
     * @throws ApiError
     */
    public static getDeliveriesDriver({
        fromDate,
        toDate,
        statuses,
        page,
        limit,
    }: {
        fromDate?: string,
        toDate?: string,
        statuses?: Array<DeliveryStatus>,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDeliveryListedDriverDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/deliveries',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
                'statuses': statuses,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetDeliveryActivitySummaryDriverResponse OK
     * @throws ApiError
     */
    public static getDeliveryActivitySummaryDriver({
        fromDate,
        toDate,
    }: {
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<GetDeliveryActivitySummaryDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/deliveries/activity-summary',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetDeliveryActivityDriverResponse OK
     * @throws ApiError
     */
    public static getDeliveryActivityDriver({
        fromDate,
        toDate,
    }: {
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<GetDeliveryActivityDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/deliveries/activity',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderDetails`
     * @returns DeliveryAdminDto OK
     * @throws ApiError
     */
    public static getDeliveryAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<DeliveryAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/deliveries/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns DeliveryAdminDto OK
     * @throws ApiError
     */
    public static postCancelDeliveryAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostCancelDeliveryAdminRequest,
    }): CancelablePromise<DeliveryAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/deliveries/{id}/cancel',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
